import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var StepContent = function (_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, _c = _a.show, show = _c === void 0 ? false : _c;
    return (_jsx(_Fragment, { children: show ? (_jsx(_Fragment, { children: children })) : null }));
};
